export default "__VITE_ASSET__lZeuomti__"